import { useQuery } from "@tanstack/react-query";
import apiClient from "./apiClient";

const getEventDetail = async (eventId) => {
  const url = `api/event/${eventId}`;
  const { data } = await apiClient.get(url);
  return data;
};

const useGetEventDetail = (eventId) => {
  return useQuery({
    queryKey: ["eventDetail", eventId],
    queryFn: () => getEventDetail(eventId),
    staleTime: 1000 * 60 * 60 * 2, // Cache for 2 hours
    cacheTime: 1000 * 60 * 60 * 2, // Keep cache for 2 hours
    enabled: !!eventId, // Only run query if eventId exists
  });
};

export default useGetEventDetail;
